import {styled} from "@mui/material/styles";

export interface ListingImgStyleProps {
  objectfit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  height?: string;
  width?: string;
  borderRadius?: string;
}

export const ListingImgContainer = styled('div')(({
                                                    height = '11.42em',
                                                    width = '20em',
                                                    borderRadius = '0.57143em'
                                                  }: ListingImgStyleProps) => ({
  height: height,
  width: width,
  borderRadius: borderRadius,
  overflow: "hidden"
}));

export const ListingImg = styled('img')(({objectfit = 'cover'}: ListingImgStyleProps) => ({
  height: "100%",
  width: "100%",
  objectFit: objectfit,
}));
